import { useContext } from "react";
import _ from "lodash";
import { renderHeaderTable } from "./SummaryHeader";
import JobUtils from "../../utils/JobsUtils";
import ConfigUtils from "../../utils/ConfigUtils";
import { SummaryContext } from "../../context/SummaryContext";
import { UserContext } from "../../context/UserContext";

const ProcessorSummary = () => {
  const jobTypes = ConfigUtils.getJobTypes();
  const { job, processorHeaders } = useContext(SummaryContext);
  const { userRole } = useContext(UserContext);
  const jobType = _.find(jobTypes, (jobTypeObject) => _.get(jobTypeObject, "jobType") === _.get(job, "jobType", ""));
  const sortProcessHeaders = JobUtils.orderProcessingSummary(processorHeaders,job);
  return _.isEmpty(job) || !_.has(job, "processor") || userRole === 'cr_api' || userRole === 'mediarequest'
    ? null
    : renderHeaderTable(
        sortProcessHeaders,
        JobUtils.updateProcess(_.get(job, "processor")),
        `Processing: ${_.get(jobType, "label")}`,
  null,
        JobUtils.getSelectedProcessingTypeLabel(job));
};

export default ProcessorSummary;
